"use strict";

var _objectWithoutProperties = require("/app/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImgComparisonSlider = void 0;

var react_1 = __importDefault(require("react"));

if (typeof document !== 'undefined') {
  Promise.resolve().then(function () {
    return __importStar(require('img-comparison-slider'));
  });
}

var ImgComparisonSlider = function ImgComparisonSlider(_ref) {
  var children = _ref.children,
      onSlide = _ref.onSlide,
      props = _objectWithoutProperties(_ref, ["children", "onSlide"]);

  var ref = react_1.default.createRef();
  react_1.default.useEffect(function () {
    if (props.value !== undefined) {
      ref.current.value = parseFloat(props.value.toString());
    }
  }, [props.value, ref]);
  react_1.default.useEffect(function () {
    if (onSlide) {
      // @ts-ignore
      ref.current.addEventListener('slide', onSlide);
    }
  }, []);
  return react_1.default.createElement('img-comparison-slider', Object.assign({
    class: props.className ? "".concat(props.className, " rendered") : 'rendered',
    // Align tabIndex between the web and React components
    // this code could be removed when
    // https://github.com/WICG/webcomponents/issues/762 is resolved.
    tabIndex: 0,
    ref: ref
  }, props), children);
};

exports.ImgComparisonSlider = ImgComparisonSlider;